import * as React from 'react';

import { connect } from 'react-redux';
import { withRouter, NavLink } from 'react-router-dom';
import { Grid } from 'semantic-ui-react';

import { localeData } from '../../../locales/data';
import { StateType } from '../../../reducers';
import {
  dataTeamCountPendingTeamsSelector,
  dataTeamCountRejectedTeamsSelector,
} from '../../../reducers/TeamReducer/DataTeamReducer/DataTeamSelector';
import { Container } from '../../Container';
import { HOCMenu } from '../../Menu';

import './TeamMenu.scss';
import { FormattedMessageHelper } from '../../../shared/helpers/internationalization';

export const MenuTeamTitle = () => (
  <h2 className="title team-menu__title">
    <FormattedMessageHelper tagName="span" id="header.team" defaultMessage={localeData.en['header.team']} />
  </h2>
);

interface MenuListTeamProps {
  numberPastTeams: number;
  numberInvitesTeams: number;
}

const MenuListTeam = ({ numberInvitesTeams }: MenuListTeamProps) => (
  <ul className="menu-top__list">
    <li className="menu-top__item">
      <NavLink to="/team/active" activeClassName="menu-top__item-btn--active" className="menu-top__item-btn menu-top__item-btn--link">
        <FormattedMessageHelper tagName="span" id="team.active" defaultMessage={localeData.en['team.active']} />
      </NavLink>
    </li>
    <li className="menu-top__item">
      <NavLink to="/team/past" activeClassName="menu-top__item-btn--active" className="menu-top__item-btn menu-top__item-btn--link">
        <FormattedMessageHelper tagName="span" id="team.past" defaultMessage={localeData.en['team.past']} />
      </NavLink>
    </li>
    <li className="menu-top__item">
      <NavLink to="/team/invitations" activeClassName="menu-top__item-btn--active" className="menu-top__item-btn menu-top__item-btn--link">
        <FormattedMessageHelper
          tagName="span"
          id="team.invites"
          defaultMessage={localeData.en['team.invites']}
          values={{
            number: numberInvitesTeams && numberInvitesTeams !== 0 ? `(${numberInvitesTeams})` : '',
          }}
        />
      </NavLink>
    </li>
  </ul>
);

const mapStateToProps = (state: StateType): MenuListTeamProps => ({
  // @ts-ignore
  numberPastTeams: dataTeamCountRejectedTeamsSelector(state),
  // @ts-ignore
  numberInvitesTeams: dataTeamCountPendingTeamsSelector(state),
});

const MenuListTeamconnect = withRouter(connect<MenuListTeamProps, {}, any, StateType>(mapStateToProps, {})(MenuListTeam));

const WrappedMenu = HOCMenu(MenuTeamTitle, null, null, null, MenuListTeamconnect);

export const TeamMenu = () => (
  <Container>
    <Grid>
      <Grid.Column computer={16}>
        <div className="team-menu">
          <WrappedMenu type="team" />
        </div>
      </Grid.Column>
    </Grid>
  </Container>
);
